import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';

const useGetSheetValue = () => {
  const sheetDb = useSelector((state: RootState) => state.sheetDb);

  const getSheetValue = (id?: string | null) => {
    return !id ? undefined : sheetDb.sheets[id];
  }
  return getSheetValue;
}

export default useGetSheetValue;
